/** Map helpers shared by the order form and the project pages. */

export const mapsUrl = (lat: number, lng: number) =>
  `https://www.google.com/maps/search/?api=1&query=${lat.toFixed(6)},${lng.toFixed(6)}`;

export const num = (v: string | number | null | undefined): number | null => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/** Rough centres so the map opens on the right emirate before a pin exists. */
export const EMIRATE_CENTRE: Record<string, [number, number]> = {
  Dubai: [25.2048, 55.2708],
  "Abu Dhabi": [24.4539, 54.3773],
  Sharjah: [25.3463, 55.4209],
  Ajman: [25.4052, 55.5136],
  "Umm Al Quwain": [25.5647, 55.5552],
  "Ras Al Khaimah": [25.7895, 55.9432],
  Fujairah: [25.1288, 56.3265],
};
